import styles from "./SpinLoader.module.scss";

const SpinLoader: React.FC = () => {
  return (
    <div className={styles.loader}>
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="28.5" stroke="#E6E6E6" strokeWidth="3" />
        <path
          d="M30 -1.31134e-06C33.9397 -1.48355e-06 37.8407 0.775973 41.4805 2.28361C45.1203 3.79125 48.4274 6.00104 51.2132 8.78679C53.999 11.5726 56.2087 14.8797 57.7164 18.5195C59.224 22.1593 60 26.0603 60 30L57 30C57 26.4543 56.3016 22.9433 54.9447 19.6675C53.5879 16.3918 51.5991 13.4153 49.0919 10.9081C46.5847 8.40093 43.6082 6.41213 40.3325 5.05525C37.0567 3.69837 33.5457 3 30 3L30 -1.31134e-06Z"
          fill="url(#paint0_linear_1172_14020)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1172_14020"
            x1="67"
            y1="66.5454"
            x2="9.61462"
            y2="-12.6844"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6200FF" />
            <stop offset="1" stopColor="#05ECFF" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default SpinLoader;
